export const addresses = {
  pnouns: "0x0bC4A7b89FbdDB6623401Bb4fB12b358861E3B86",
};
